import { render } from "./md-color-wand.vue?vue&type=template&id=efce62ba"
import script from "./md-color-wand.vue?vue&type=script&lang=js"
export * from "./md-color-wand.vue?vue&type=script&lang=js"
script.render = render

export default script